import { HTMLAttributes, JSX } from 'react';
import styles from './highlightedMessage.module.less';

/**
 * Highlights all tokens in a given text
 * @returns Array of React nodes with highlighted keywords
 * @param props
 */
export function HighlightedMessage(props: {
    text: string;
    tokens: string[];
    tokenProps?: HTMLAttributes<HTMLSpanElement>;
}): JSX.Element {
    const { text, tokens, tokenProps } = props;
    // A regex pattern that matches any of the keywords
    const tokenPattern = new RegExp(
        `(${tokens.map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`,
        'g'
    );

    const parts = text.split(tokenPattern);
    return (
        <>
            {parts.map((part, index) => {
                // If it's a keyword, wrap it in a styled span, otherwise return the text
                return tokens.includes(part) ? (
                    <span key={`keyword-${index}`} className={styles.token} {...tokenProps}>
                        {part}
                    </span>
                ) : (
                    part
                );
            })}
        </>
    );
}
